import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=2fe45588&scoped=true&"
import script from "./Transition.vue?vue&type=script&lang=js&"
export * from "./Transition.vue?vue&type=script&lang=js&"
import style0 from "./Transition.vue?vue&type=style&index=0&id=2fe45588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe45588",
  null
  
)

export default component.exports